import { render, staticRenderFns } from "./nftbill.vue?vue&type=template&id=3e070438&scoped=true"
import script from "./nftbill.vue?vue&type=script&lang=js"
export * from "./nftbill.vue?vue&type=script&lang=js"
import style0 from "./nftbill.vue?vue&type=style&index=0&id=3e070438&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e070438",
  null
  
)

export default component.exports